export default __webpack_public_path__ + "static/media/Flag_of_Turks_and_Caicos_Islands.0c3c92aa.svg";